/*
 * ShiftDetailCardAssignmentStatus Messages
 *
 * This contains all the text for the ShiftDetailCardAssignmentStatus component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.title',
    defaultMessage: 'Assignment status',
  },
  changed: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.changed',
    defaultMessage: 'Changed',
  },
  changedDescription: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.changedDescription',
    defaultMessage:
      'Assignments in this shift are changed but not marked as planned',
  },
  committed: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.committed',
    defaultMessage: 'Planned',
  },
  committedDescription: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.committedDescription',
    defaultMessage: 'Assignments in this shift are planned but not public',
  },
  finalized: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalized',
    defaultMessage: 'Published',
  },
  finalizedDescription: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizedDescription',
    defaultMessage: 'Assignments of this shift are public',
  },
  commit: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.commit',
    defaultMessage: 'Mark as planned',
  },
  finalize: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalize',
    defaultMessage: 'Publish assignments',
  },
  finalizeConfirmTitle: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizeConfirmTitle',
    defaultMessage: 'Publish shift?',
  },
  finalizeConfirmText: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizeConfirmText',
    defaultMessage:
      'By publishing the shift you make the assignments in this shift public to all attendees.',
  },
  finalizeConfirmButton: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizeConfirmButton',
    defaultMessage: 'Publish',
  },
  finalizeConfirmCancel: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizeConfirmCancel',
    defaultMessage: 'Cancel',
  },
  finalizeShiftSucceeded: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizeShiftSucceeded',
    defaultMessage: 'Shift has been successfully finalized',
  },
  finalizeShiftFailed: {
    id: 'app.components.ShiftDetailCardAssignmentStatus.finalizeShiftFailed',
    defaultMessage: 'Error. The shift could not be finalized.',
  },
});
